import NavbarUserDropdown from "./NavbarUserDropdown";
import {
  Box,
  Grid,
  AppBar as MuiAppBar,
  IconButton as MuiIconButton,
  Toolbar,
  Button,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import SubscriptionPaymentFailedIndicator from "components/subscriptions/SubscriptionPaymentFailedIndicator";
import PageBreadcrumbs from "components/ui/PageBreadcrumbs";
import { MenuIcon, UpgradeIcon } from "components/ui/icons";
import useAccountSubscription from "hooks/useAccountSubscription";
import useAuth from "hooks/useAuth";
import * as React from "react";
import { Link } from "react-router-dom";
import styled, { withTheme } from "styled-components/macro";

const AppBar = styled(MuiAppBar)`
  background: ${(props) => props.theme.palette.appBar.background};
  color: ${(props) => props.theme.palette.appBar.color};
`;

const IconButton = styled(MuiIconButton)`
  svg {
    width: 22px;
    height: 22px;
  }
`;

const Navbar = ({ onDrawerToggle }) => {
  const { isSuperuser } = useAuth();
  const { isFreePlan, stripeRenewalFailed } = useAccountSubscription();
  const theme = useTheme();
  const isPhone = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <AppBar position="sticky" elevation={0}>
      <Toolbar>
        <Grid container alignItems="center" spacing={4}>
          <Grid item>
            <IconButton
              color="inherit"
              aria-label="Open drawer"
              onClick={onDrawerToggle}
              size="large"
            >
              <MenuIcon />
            </IconButton>
          </Grid>
          <Grid item xs sx={{ minWidth: 0 }}>
            <Box sx={{ minWidth: 0, overflow: "hidden" }}>
              <PageBreadcrumbs />
            </Box>
          </Grid>
          {!isPhone && !isSuperuser && stripeRenewalFailed && (
            <Grid item>
              <SubscriptionPaymentFailedIndicator />
            </Grid>
          )}
          {!isPhone && !isSuperuser && !stripeRenewalFailed && isFreePlan && (
            <>
              <Grid item>
                <Link to="/plans">
                  <Button
                    variant="contained"
                    startIcon={<UpgradeIcon />}
                    role="upgrade"
                  >
                    Upgrade
                  </Button>
                </Link>
              </Grid>
            </>
          )}
          {!isPhone && (
            <Grid item>
              <NavbarUserDropdown />
            </Grid>
          )}
        </Grid>
      </Toolbar>
    </AppBar>
  );
};

export default withTheme<any>(Navbar);
